export default __webpack_public_path__ + "static/media/cat19.d96fbb00.gif";